import React from 'react'


export default (props) => {
	const { setPage } = props.redux.nav
	const { nav } = props.state
	const { page } = nav[nav.length-1]
	return (
		<div className='lpa-tabs'>
			<div
				className={page === '' ? 'lpa-tab left active' : 'lpa-tab left'}
				onTouchTap={() => setPage('')}
			>
				my sign
			</div>
			<div
				className={(page === 'relationships' || page === 'add' || page === 'contact') ? 'lpa-tab middle active' : 'lpa-tab middle'}
				onTouchTap={() => {
					if (props.user) {
						setPage('relationships')
					}
					else {
						// Add small delay to prevent click-through propagation
						setTimeout(() => setPage('login'), 20)
					}
				}}
			>
				relationships
			</div>
			<div
				className={page === 'lookup' ? 'lpa-tab right active' : 'lpa-tab right'}
				onTouchTap={() => {
					if (props.user) {
						setPage('lookup')
					}
					else {
						// Add small delay to prevent click-through propagation
						setTimeout(() => setPage('login'), 20)
					}
				}}
			>
				lookup
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Home/Tabs.js